/**
 * Delivery preference.
 *
 * Checkout has no setting for which of "Ship" / "Pick up" opens selected. The
 * only documented lever is a delivery preference on the cart, which checkout
 * uses to prefill its delivery section. The theme cart and the Storefront API
 * cart are the same object, so the preference is set through the Storefront
 * API, once per cart.
 */
(() => {
  const STORAGE_KEY = 'munne:delivery-preference';
  const API_VERSION = '2026-07';
  const MUTATION = `
    mutation ($cartId: ID!) {
      cartBuyerIdentityUpdate(
        cartId: $cartId
        buyerIdentity: { preferences: { delivery: { deliveryMethod: [SHIPPING] } } }
      ) {
        userErrors {
          message
        }
      }
    }
  `;

  function isStored(token) {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === token;
    } catch (error) {
      return false;
    }
  }

  function store(token) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, token);
    } catch (error) {
      // Blocked storage only means the mutation repeats on the next page.
    }
  }

  async function preferShipping() {
    const root = window.Shopify.routes.root;

    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      if (cart.item_count === 0 || isStored(cart.token)) return;

      const response = await fetch(`${root}api/${API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: MUTATION,
          variables: { cartId: `gid://shopify/Cart/${cart.token}` },
        }),
      });
      const { data, errors } = await response.json();
      const userErrors = data?.cartBuyerIdentityUpdate?.userErrors ?? [];

      if (errors || userErrors.length > 0) {
        console.warn('munne-delivery-preference', errors || userErrors);
        return;
      }

      store(cart.token);
    } catch (error) {
      // Checkout still works without the preference; it only loses the default.
      console.warn('munne-delivery-preference', error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    preferShipping();
    subscribe(PUB_SUB_EVENTS.cartUpdate, preferShipping);
  });
})();
